function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M2000 50c1077,0 1950,873 1950,1950 0,1077 -873,1950 -1950,1950 -1077,0 -1950,-873 -1950,-1950 0,-1077 873,-1950 1950,-1950zm0 287c919,0 1663,745 1663,1663 0,919 -745,1663 -1663,1663 -919,0 -1663,-745 -1663,-1663 0,-919 745,-1663 1663,-1663z"
}), React.createElement("path", {
  d: "M1397 1277l603 603 603 -603c51,-51 135,-51 186,0l0 0c51,51 51,135 0,186l-603 603 603 603c51,51 51,135 0,186l0 0c-51,51 -135,51 -186,0l-603 -603 -603 603c-51,51 -135,51 -186,0l0 0c-51,-51 -51,-135 0,-186l603 -603 -603 -603c-51,-51 -51,-135 0,-186l0 0c51,-51 135,-51 186,0z"
}));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "4000px",
    height: "4000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4000 4000",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.c5137480.svg";
export { ForwardRef as ReactComponent };